<mat-card class="top-card mat-elevation-z0" *ngIf="!getTypeExists()">
  <form class="flexer">
    <div class="form-title">
      <div class="form-title-text">Type project</div>
    </div>

    <mat-form-field class="first-form-field" appearance="outline">
      <mat-label>Maak een keuze</mat-label>
      <mat-select
        name="projectType"
        [(ngModel)]="productType"
        (ngModelChange)="selectType($event)"
        matInput
        placeholder="Maak een keuze"
        [disabled]="disabled"
        required
      >
        <mat-option *ngFor="let option of projectOptions" [value]="option">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</mat-card>
<product-wrapper
  *ngIf="getTypeExists()"
  [inputProject]="inputProject"
  [inputProduct]="inputProduct"
  [index]="index"
  [involvedCompanies]="involvedCompanies"
  [pmsColorAdded]="pmsColorAdded"
  [standardStickerPartDeleted]="standardStickerPartDeleted"
  [client]="client"
  [fromOldSystem]="fromOldSystem"
  [disabled]="disabled"
  [isCollapsed]="isCollapsed"
  (outputProduct)="updateProject.emit()"
>
</product-wrapper>
